import React from 'react';
import { useTranslation } from 'react-i18next';
import useCoordinateMeeting from '../hookss/useCoordinateMeeting';
import { CONTROLER_ACTION_KEYS } from './constant';
const ControllerMeeting = () => {
    const { t } = useTranslation();
    const { handleClick } = useCoordinateMeeting();
    return (React.createElement("div", { style: { marginTop: '12px' } },
        React.createElement("div", { className: 'controller-meeting-header controler-header' }, t('menuController.coordinate')),
        React.createElement("div", { className: "controler-list-item" },
            React.createElement("div", { className: "controler-item item-tab shape-button", onClick: () => handleClick('pinnedForAll') }, t('menuController.pinnedForAll')),
            React.createElement("div", { className: "controler-item item-tab shape-button", onClick: () => handleClick('controlLayout') }, t('menuController.layoutForAll')),
            React.createElement("div", { className: "controler-item item-tab shape-button", onClick: () => handleClick(CONTROLER_ACTION_KEYS.SORT_PARTICIPANTS_CTH) }, t('menuController.sortParticipantsForAll')))));
};
export default ControllerMeeting;
